// extracted by mini-css-extract-plugin
export default {"listWrapper":"list__listWrapper-IgAr5","list":"list__list-HdwVU","listFooter":"list__listFooter-ZJMi9","error":"list__error-Wft9w"};